import React from 'react';

export default class Glossary extends React.Component {
    render() {
        return (
            <div className="Glossary">
                <h1>Guide to the metrics</h1>
                <h2>Total citations</h2>
                <p>
                    This is the total number of times a publication has been cited. We count citations from the
                    reference list in all publications that have been indexed by Dimensions.
                </p>
                <h2>Recent citations</h2>
                <p>The recent citations value is the number of citations that were received in the last two years.</p>
                <h2>Field Citation Ratio (FCR)</h2>
                <p>
                    The Field Citation Ratio (FCR) indicates the relative citation performance of an article, when
                    compared to similarly-aged articles in its subject area. The FCR is normalized to 1.0 for this
                    selection of articles. An FCR value of more than 1.0 shows that the publication has a higher than
                    average number of citations for its group (defined by its FoR subject code and publication year).
                </p>
                <p>
                    Articles that are less than 2 years old do not have an FCR. An article with zero citations has an
                    FCR of 0.
                </p>
                <h2>Relative Citation Ratio (RCR)</h2>
                <p>
                    The Relative Citation Ratio (RCR) indicates the relative citation performance of an article, when
                    compared to other articles in its area of research. The RCR is normalized to 1.0 and calculated for
                    all articles funded by the NIH in the Dimensions catalog. An RCR of more than 1.0 shows that a
                    publication has an above average citation rate for its group, when defined by the subject area
                    citation rates of the articles that have been cited with it.
                </p>
                <p>Articles that are less than 2 years old, or do not have citations, do not have an RCR.</p>
                <h1>Where can I find out more?</h1>
                <p>
                    Please visit our{' '}
                    <a href="https://support.dimensions.ai/support/home" rel="noopener noreferrer" target="_blank">
                        Support Center
                    </a>{' '}
                    to read more about Dimensions or email us at{' '}
                    <a href="mailto: support@dimensions.ai">support@dimensions.ai</a>.
                </p>
            </div>
        );
    }
}
